<template>
  <div id='content'>
    <v-header></v-header>
    <div class="margintop contentCon">
      <el-tabs v-model="activeName1" @tab-click="handleClick" v-if="active">
        <el-tab-pane label="新闻类" name="first">
          <template>
            <div class='searchParam'>
              <el-row>
                <el-col :span='5'>
                  标题&nbsp;&nbsp;<el-input class="input60" placeholder='请输入标题' v-model="title"></el-input>
                </el-col>
                <el-col :span='5'>
                  关键字&nbsp;&nbsp;<el-input class="input60" placeholder='请输入关键字' v-model="keyword"></el-input>
                </el-col>
                <el-col :span='6'>
                  发布状态&nbsp;&nbsp;
                  <el-select v-model="value" class="input60" placeholder="请选择发布状态">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="search">搜索</el-button>
              </el-row>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%" text-align="center" :height='tableHeight'>
              <el-table-column
                prop="id"
                label="内容ID"
                v-if= 'false'>
              </el-table-column>
              <el-table-column width="50">
                <template slot-scope="scope">
                  <span v-if='scope.row.isHeadline' class="badge" :class="{'headline':scope.row.headlineState}">头条</span>
                  <span v-else></span>
                </template>
                <!-- <template slot-scope="scope">
                    <el-badge value="头条" class="item"  v-if="scope.row.isHeadline">
                      <span style="margin-left: 10px"></span>
                    </el-badge>
                    <span style="margin-left: 10px" v-else></span>
                </template> -->
              </el-table-column>
              <el-table-column
                prop="visiblePeople"
                label="可见范围"
                width="110"
                :formatter='visiblePeople'>
              </el-table-column>
              <el-table-column
                prop="keywords"
                label="关键字"
                width="150">
                <template slot-scope="scope">
                  <div style="display:inline-block;margin:5px;text-align:left" v-for="(item,index) of scope.row.keywords" :key="index">
                    <el-tag v-if="item.length >= 6">{{item.substr(0,7)}}...</el-tag>
                    <el-tag v-else>{{item}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="标题"
                width="220">
              </el-table-column>
              <el-table-column
                prop="contentType"
                label="来源"
                width="120"
                :formatter='contentTypes'>
              </el-table-column>
              <el-table-column
                prop="publishPersion"
                label="发布人"
                width="120">
              </el-table-column>
              <el-table-column
                prop="publishTime"
                label="发布时间"
                width="100">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.publishTime" placement="top">
                    <p style="text-align:center">{{ scope.row.publishTime }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.publishTime.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="unshelveDate"
                label="下架时间"
                width="100">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.unshelveDate" placement="top">
                    <p style="text-align:center">{{ scope.row.unshelveDate }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.unshelveDate.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="publishStatus"
                label="发布状态"
                width="110"
                :formatter="formatStatus">
              </el-table-column>
              <el-table-column
                prop="address"
                label="发布地址"
                width="110">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.address" placement="top">
                    <p style="text-align:center">{{ scope.row.address }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.address.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="isStick"
                label="是否置顶"
                v-if = 'false'
              >
              </el-table-column>
              <el-table-column
                prop="isPublishMethod"
                label="是否置顶"
                v-if = 'false'
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width='320' style="text-align:center">
                <template slot-scope="scope">
                  <el-button
                    v-show="false"
                    size="mini"
                    @click="publish(scope.row)">占位</el-button>
                  <el-button
                    v-show="scope.row.publishStatus == 0 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 1"
                    size="mini"
                    @click="repealPublish(scope.row)">撤销发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod == 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishMethod != 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod != 1 && scope.row.publishStatus != 1"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="update(scope.row)">修改发布时间</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="cancelData(scope.row)">取消</el-button>
                    <el-button
                    v-show="scope.row.isStick == 0"
                    size="mini"
                    @click="stick(scope.row)">置顶</el-button>
                    <el-button
                    v-show="scope.row.isStick == 1"
                    size="mini"
                    type="info"
                    @click="alreadyStick(scope.row)">已置顶</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size= "pagesize"
              :current-page="currentPage"
              layout="total, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            <div class="publishDialog">
              <el-dialog
                title="提示"
                :visible.sync="publishVisible"
                width="30%"
                :before-close="publishClose">
                <span>{{publishContent}}，是否确认发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="publishVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="repealDialog">
              <el-dialog
                title="提示"
                :visible.sync="repealVisible"
                width="30%"
                :before-close="repealClose">
                <span>{{publishContent}}，正在发布中，是否确认撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="repealVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="deleteDialog">
              <el-dialog
                title="提示"
                :visible.sync="deleteVisible"
                width="30%"
                :before-close="deleteClose">
                <span>{{publishContent}}，确认删除？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="deleteVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isDelete">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="stickDialog">
              <el-dialog
                title="提示"
                :visible.sync="stickVisible"
                width="30%"
                :before-close="stickClose">
                <span>{{publishContent}}，确认置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="stickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="alreadyStickDialog">
              <el-dialog
                title="提示"
                :visible.sync="alreadyStickVisible"
                width="30%"
                :before-close="alreadyStickClose">
                <span>{{publishContent}}，已经置顶，是否取消置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="alreadyStickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="cancelTimingDialog">
              <el-dialog
                title="提示"
                :visible.sync="cancelTimingVisible"
                width="30%"
                :before-close="cancelTimingClose">
                <span>{{publishContent}}，确认取消定时发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelTimingVisible = false">取 消</el-button>
                  <el-button type="primary" @click="cancelTiming">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updateDialog">
              <el-dialog
                title="提示"
                :visible.sync="updateVisible"
                width="30%"
                :before-close="updateClose">
                该内容将于&nbsp;&nbsp;
                <el-date-picker
                  v-model="updateDate"
                  :editable='false'
                  :clearable='false'
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
                &nbsp;&nbsp;发布
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelUpdate">取 消</el-button>
                  <el-button type="primary" @click="updatePublish">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updatePublishDialog">
              <el-dialog
                title="提示"
                :visible.sync="updatePublishVisible"
                width="30%"
                :before-close="updatePublishClose">
                <span>{{publishContent}}，正在发布中，编辑需要撤销发布，是否撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="updatePublishVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="产品类" name="second">
          <template>
            <div class='searchParam'>
              <el-row>
                <el-col :span='6'>产品名称&nbsp;&nbsp;
                  <el-input class="input60" placeholder='请输入标题' v-model="title"></el-input>
                </el-col>
                <el-col :span='5'>关键字&nbsp;&nbsp;
                  <el-input class="input60" placeholder='请输入关键字' v-model="keyword"></el-input>
                </el-col>
                <el-col :span='6'>发布状态&nbsp;&nbsp;
                  <el-select v-model="value" class="input60" placeholder="请选择发布状态">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="search">搜索</el-button>
              </el-row>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%" text-align="center" :height='tableHeight'>
              <el-table-column
                prop="id"
                label="内容ID"
                v-if= 'false'
                >
              </el-table-column>
              <el-table-column
                prop="visiblePeople"
                label="可见范围"
                width="110"
                :formatter='visiblePeople'>
              </el-table-column>
              <el-table-column
                prop="keywords"
                label="关键字"
                width="220">
                <template slot-scope="scope">
                  <div style="display:inline-block;margin:5px;text-align:left" v-for="(item,index) of scope.row.keywords" :key="index">
                    <el-tag>{{item}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="title"
                label="产品名称"
                width="150">
              </el-table-column>
              <el-table-column
                prop="publishPersion"
                label="发布人"
                width="120">
              </el-table-column>
              <el-table-column
                prop="publishTime"
                label="发布时间"
                width="100">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.publishTime" placement="top">
                    <p style="text-align:center">{{ scope.row.publishTime }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.publishTime.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="unshelveDate"
                label="下架时间"
                width="100">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.unshelveDate" placement="top">
                    <p style="text-align:center">{{ scope.row.unshelveDate }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.unshelveDate.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="publishStatus"
                label="发布状态"
                width="110"
                :formatter="formatStatus">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作" width='320' style="text-align:center">
                <template slot-scope="scope">
                  <el-button
                    v-show="false"
                    size="mini"
                    @click="publish(scope.row)">占位</el-button>
                  <el-button
                    v-show="scope.row.publishStatus == 0 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 1"
                    size="mini"
                    @click="repealPublish(scope.row)">撤销发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod == 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishMethod != 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod != 1 && scope.row.publishStatus != 1"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="update(scope.row)">修改发布时间</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="cancelData(scope.row)">取消</el-button>
                    <el-button
                    v-show="scope.row.isStick == 0"
                    size="mini"
                    @click="stick(scope.row)">置顶</el-button>
                    <el-button
                    v-show="scope.row.isStick == 1"
                    size="mini"
                    type="info"
                    @click="alreadyStick(scope.row)">已置顶</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size= "pagesize"
              :current-page="currentPage"
              layout="total, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            <div class="publishDialog">
              <el-dialog
                title="提示"
                :visible.sync="publishVisible"
                width="30%"
                :before-close="publishClose">
                <span>{{publishContent}}，是否确认发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="publishVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="repealDialog">
              <el-dialog
                title="提示"
                :visible.sync="repealVisible"
                width="30%"
                :before-close="repealClose">
                <span>{{publishContent}}，正在发布中，是否确认撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="repealVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="deleteDialog">
              <el-dialog
                title="提示"
                :visible.sync="deleteVisible"
                width="30%"
                :before-close="deleteClose">
                <span>{{publishContent}}，确认删除？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="deleteVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isDelete">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="stickDialog">
              <el-dialog
                title="提示"
                :visible.sync="stickVisible"
                width="30%"
                :before-close="stickClose">
                <span>{{publishContent}}，确认置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="stickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="alreadyStickDialog">
              <el-dialog
                title="提示"
                :visible.sync="alreadyStickVisible"
                width="30%"
                :before-close="alreadyStickClose">
                <span>{{publishContent}}，已经置顶，是否取消置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="alreadyStickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="cancelTimingDialog">
              <el-dialog
                title="提示"
                :visible.sync="cancelTimingVisible"
                width="30%"
                :before-close="cancelTimingClose">
                <span>{{publishContent}}，确认取消定时发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelTimingVisible = false">取 消</el-button>
                  <el-button type="primary" @click="cancelTiming">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updateDialog">
              <el-dialog
                title="提示"
                :visible.sync="updateVisible"
                width="30%"
                :before-close="updateClose">
                该内容将于&nbsp;&nbsp;
                <el-date-picker
                  v-model="updateDate"
                  :editable='false'
                  :clearable='false'
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
                &nbsp;&nbsp;发布
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelUpdate">取 消</el-button>
                  <el-button type="primary" @click="updatePublish">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updatePublishDialog">
              <el-dialog
                title="提示"
                :visible.sync="updatePublishVisible"
                width="30%"
                :before-close="updatePublishClose">
                <span>{{publishContent}}，正在发布中，编辑需要撤销发布，是否撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="updatePublishVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="轮播类" name="third">
          <template>
            <div class='searchParam'>
              <el-row>
                <el-col :span='5'>关键字&nbsp;&nbsp;
                  <el-input class="input60" placeholder='请输入关键字' v-model="keyword"></el-input>
                </el-col>
                <el-col :span='6'>发布状态&nbsp;&nbsp;
                  <el-select v-model="value" class="input60" placeholder="请选择发布状态">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="search">搜索</el-button>
              </el-row>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%" text-align="center" :height='tableHeight'>
              <el-table-column
                prop="id"
                label="内容ID"
                v-if= 'false'
                >
              </el-table-column>
              <el-table-column
                prop="visiblePeople"
                label="可见范围"
                width="110"
                :formatter='visiblePeople'>
              </el-table-column>
              <el-table-column
                prop="keywords"
                label="关键字"
                width="220">
                <template slot-scope="scope">
                  <div style="display:inline-block;margin:5px;text-align:left" v-for="(item,index) of scope.row.keywords" :key="index">
                    <el-tag>{{item}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="publishPersion"
                label="发布人"
                width="150">
              </el-table-column>
              <el-table-column
                prop="publishTime"
                label="发布时间"
                width="150">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.publishTime" placement="top">
                    <p style="text-align:center">{{ scope.row.publishTime }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.publishTime.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="unshelveDate"
                label="下架时间"
                width="150">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.unshelveDate" placement="top">
                    <p style="text-align:center">{{ scope.row.unshelveDate }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.unshelveDate.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="publishStatus"
                label="发布状态"
                width="110"
                :formatter="formatStatus">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作" width='320' style="text-align:center">
                <template slot-scope="scope">
                  <el-button
                    v-show="false"
                    size="mini"
                    @click="publish(scope.row)">占位</el-button>
                  <el-button
                    v-show="scope.row.publishStatus == 0 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 1"
                    size="mini"
                    @click="repealPublish(scope.row)">撤销发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod == 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishMethod != 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod != 1 && scope.row.publishStatus != 1"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="update(scope.row)">修改发布时间</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="cancelData(scope.row)">取消</el-button>
                    <el-button
                    v-show="scope.row.isStick == 0"
                    size="mini"
                    @click="stick(scope.row)">置顶</el-button>
                    <el-button
                    v-show="scope.row.isStick == 1"
                    size="mini"
                    type="info"
                    @click="alreadyStick(scope.row)">已置顶</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size= "pagesize"
              :current-page="currentPage"
              layout="total, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            <div class="publishDialog">
              <el-dialog
                title="提示"
                :visible.sync="publishVisible"
                width="30%"
                :before-close="publishClose">
                <span>是否确认发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="publishVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="repealDialog">
              <el-dialog
                title="提示"
                :visible.sync="repealVisible"
                width="30%"
                :before-close="repealClose">
                <span>正在发布中，是否确认撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="repealVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="deleteDialog">
              <el-dialog
                title="提示"
                :visible.sync="deleteVisible"
                width="30%"
                :before-close="deleteClose">
                <span>确认删除？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="deleteVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isDelete">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="stickDialog">
              <el-dialog
                title="提示"
                :visible.sync="stickVisible"
                width="30%"
                :before-close="stickClose">
                <span>确认置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="stickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="alreadyStickDialog">
              <el-dialog
                title="提示"
                :visible.sync="alreadyStickVisible"
                width="30%"
                :before-close="alreadyStickClose">
                <span>已置顶，是否取消置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="alreadyStickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="cancelTimingDialog">
              <el-dialog
                title="提示"
                :visible.sync="cancelTimingVisible"
                width="30%"
                :before-close="cancelTimingClose">
                <span>确认取消定时发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelTimingVisible = false">取 消</el-button>
                  <el-button type="primary" @click="cancelTiming">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updateDialog">
              <el-dialog
                title="提示"
                :visible.sync="updateVisible"
                width="30%"
                :before-close="updateClose">
                该内容将于&nbsp;&nbsp;
                <el-date-picker
                  v-model="updateDate"
                  :editable='false'
                  :clearable='false'
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
                &nbsp;&nbsp;发布
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelUpdate">取 消</el-button>
                  <el-button type="primary" @click="updatePublish">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updatePublishDialog">
              <el-dialog
                title="提示"
                :visible.sync="updatePublishVisible"
                width="30%"
                :before-close="updatePublishClose">
                <span>正在发布中，编辑需要撤销发布，是否撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="updatePublishVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div>
              <el-dialog
                title="提示"
                :visible.sync="caroDialogVisible"
                width="30%"
                :before-close="caroHandleClose">
                <span>轮播数量已超过5条，请注意设备显示问题！</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="caroDialogVisible = false">取消发布</el-button>
                  <el-button type="primary" @click="caroDialog">确认发布</el-button>
                </span>
              </el-dialog>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="通知类" name="four">
          <template>
            <div class='searchParam'>
              <el-row>
                <el-col :span='5'>关键字&nbsp;&nbsp;
                  <el-input class="input60" placeholder='请输入关键字' v-model="keyword"></el-input>
                </el-col>
                <el-col :span='6'>发布状态&nbsp;&nbsp;
                  <el-select v-model="value" class="input60" placeholder="请选择发布状态">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="search">搜索</el-button>
              </el-row>
            </div>
            <el-table
              :data="tableData"
              style="width: 100%" text-align="center" :height='tableHeight'>
              <el-table-column
                prop="id"
                label="内容ID"
                v-if= 'false'
                >
              </el-table-column>
              <el-table-column
                prop="visiblePeople"
                label="可见范围"
                width="110"
                :formatter='visiblePeople'>
              </el-table-column>
              <el-table-column
                prop="keywords"
                label="关键字"
                width="220">
                <template slot-scope="scope">
                  <div style="display:inline-block;margin:5px;text-align:left" v-for="(item,index) of scope.row.keywords" :key="index">
                    <el-tag>{{item}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="publishPersion"
                label="发布人"
                width="150">
              </el-table-column>
              <el-table-column
                prop="publishTime"
                label="发布时间"
                width="150">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.publishTime" placement="top">
                    <p style="text-align:center">{{ scope.row.publishTime }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.publishTime.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="unshelveDate"
                label="下架时间"
                width="150">
                <template slot-scope="scope">
                  <el-popover trigger="hover" v-if="scope.row.unshelveDate" placement="top">
                    <p style="text-align:center">{{ scope.row.unshelveDate }}</p>
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">{{ scope.row.unshelveDate.substr(0,6) }}...</el-tag>
                    </div>
                  </el-popover>
                  <div v-else slot="reference">-</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="publishStatus"
                label="发布状态"
                width="110"
                :formatter="formatStatus">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作" width='320' style="text-align:center">
                <template slot-scope="scope">
                  <el-button
                    v-show="false"
                    size="mini"
                    @click="publish(scope.row)">占位</el-button>
                  <el-button
                    v-show="scope.row.publishStatus == 0 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 1"
                    size="mini"
                    @click="repealPublish(scope.row)">撤销发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod != 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishStatus == 2 && scope.row.publishMethod == 1"
                    size="mini"
                    @click="publish(scope.row)">发布</el-button>
                    <el-button
                    v-show="scope.row.publishMethod != 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 1"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    size="mini"
                    @click="redact(scope.row)">编辑</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod != 1 && scope.row.publishStatus != 1"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    size="mini"
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 2"
                    @click="deleteData(scope.row)">删除</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="update(scope.row)">修改发布时间</el-button>
                    <el-button
                    v-show="scope.row.publishMethod == 1 && scope.row.publishStatus == 0"
                    size="mini"
                    @click="cancelData(scope.row)">取消</el-button>
                    <el-button
                    v-show="scope.row.isStick == 0"
                    size="mini"
                    @click="stick(scope.row)">置顶</el-button>
                    <el-button
                    v-show="scope.row.isStick == 1"
                    size="mini"
                    type="info"
                    @click="alreadyStick(scope.row)">已置顶</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size= "pagesize"
              :current-page="currentPage"
              layout="total, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            <div class="publishDialog">
              <el-dialog
                title="提示"
                :visible.sync="publishVisible"
                width="30%"
                :before-close="publishClose">
                <span>是否确认发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="publishVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="repealDialog">
              <el-dialog
                title="提示"
                :visible.sync="repealVisible"
                width="30%"
                :before-close="repealClose">
                <span>正在发布中，是否确认撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="repealVisible = false">取 消</el-button>
                  <el-button type="primary" @click= "isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="deleteDialog">
              <el-dialog
                title="提示"
                :visible.sync="deleteVisible"
                width="30%"
                :before-close="deleteClose">
                <span>确认删除？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="deleteVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isDelete">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="stickDialog">
              <el-dialog
                title="提示"
                :visible.sync="stickVisible"
                width="30%"
                :before-close="stickClose">
                <span>确认置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="stickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(1)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="alreadyStickDialog">
              <el-dialog
                title="提示"
                :visible.sync="alreadyStickVisible"
                width="30%"
                :before-close="alreadyStickClose">
                <span>已置顶，是否取消置顶？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="alreadyStickVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isStick(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="cancelTimingDialog">
              <el-dialog
                title="提示"
                :visible.sync="cancelTimingVisible"
                width="30%"
                :before-close="cancelTimingClose">
                <span>确认取消定时发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelTimingVisible = false">取 消</el-button>
                  <el-button type="primary" @click="cancelTiming">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updateDialog">
              <el-dialog
                title="提示"
                :visible.sync="updateVisible"
                width="30%"
                :before-close="updateClose">
                该内容将于&nbsp;&nbsp;
                <el-date-picker
                  v-model="updateDate"
                  :editable='false'
                  :clearable='false'
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
                &nbsp;&nbsp;发布
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancelUpdate">取 消</el-button>
                  <el-button type="primary" @click="updatePublish">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div class="updatePublishDialog">
              <el-dialog
                title="提示"
                :visible.sync="updatePublishVisible"
                width="30%"
                :before-close="updatePublishClose">
                <span>正在发布中，编辑需要撤销发布，是否撤销发布？</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="updatePublishVisible = false">取 消</el-button>
                  <el-button type="primary" @click="isPublish(0)">确 定</el-button>
                </span>
              </el-dialog>
            </div>
            <div>
              <el-dialog
                title="提示"
                :visible.sync="caroDialogVisible"
                width="30%"
                :before-close="caroHandleClose">
                <span>轮播数量已超过5条，请注意设备显示问题！</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="caroDialogVisible = false">取消发布</el-button>
                  <el-button type="primary" @click="caroDialog">确认发布</el-button>
                </span>
              </el-dialog>
            </div>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-button size="medium" id="add" @click="handleClickLeft">{{add_new_content}}</el-button>
      <div class="all-form" v-if="!active">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="490px" class="demo-ruleForm">
          <el-form-item label="发布类型" prop="publishType" required>
            <br/>
            <el-select v-model="ruleForm.publishType">
              <el-option v-for="item in publishTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="人员可见" prop="visiblePeople" required>
            <br/>
            <el-select v-model="ruleForm.visiblePeople">
              <el-option v-for="item in visiblePeopleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="关键字(多个关键字请用英文逗号分隔，请不要超过10个字)" prop="keywords">
            <br/>
            <el-input v-model="ruleForm.keywords" placeholder='请输入关键字'></el-input>
          </el-form-item> -->
          <el-form-item label="关键字(最多5个关键词，每个关键词不超过10个字)" prop="keywords">
            <br/>
            <el-tag :key="tag" v-for="tag in ruleForm.keywords" closable :disable-transitions="false" @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 点击添加关键字</el-button>
          </el-form-item>
          <el-form-item label="产品名称(请求不要超过25个字)" v-if="add_prod" prop="title">
            <br>
            <el-input v-model="ruleForm.title" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品介绍(请求不要超过25个字)" v-if="add_prod" prop="prodIntroducton">
            <br>
            <el-input v-model="ruleForm.prodIntroducton" placeholder="请输入产品介绍"></el-input>
          </el-form-item>
          <el-form-item label="产品地址（以http://或https://开头）" v-if="add_prod" prop="pageUrl">
            <br>
            <el-input v-model="ruleForm.pageUrl" placeholder="请输入产品地址"></el-input>
          </el-form-item>
          <el-form-item :label="thumbnail_pic" v-if="ruleForm.publishType !== 'NOTICE'" prop="picUrl" ref="uploadElement">
            <br/>
            <!-- <el-upload
              v-model ="ruleForm.picUrl"
              class="upload-demo"
              :action= "uploadUrl"
              :headers = "header"
              :data="uploadData"
              :file-list="fileList2"
              :limit= 1
              :auto-upload = true
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :on-change="handlePictureCardPreview"
              :before-upload="beforeUpload"
              list-type="picture"
              >
              <el-button size="small" type="primary" >点击上传</el-button>
            </el-upload> -->
              <!-- <div v-show="showPhotodiv"> -->
              <input type="hidden" v-model="ruleForm.picUrl">
              <div class="uploadImg" v-if="!changeImg">
                <el-button size="medium">
                  上传图片
                  <input type="file" id="uploadtImgtx" accept="image/*" @change="change123($event)">
                </el-button>
              </div>
              <el-button @click="setChangeImg" v-if="changeImg" id="changeImgBtn" size="medium">更换图片</el-button>
              <div v-show= "!redactImg">
                <div class="k" v-show="!cutImg"></div>
              </div>
              <div v-show="redactImg">
                <img id="redactImg" :src= "imgUrl">
              </div>
              <div id="clipArea" v-show="cutImg"></div>
              <!--<input type="file" id="file">-->
              <!-- <div @click="showPhotodiv=false">取消</div> -->
              <!-- <div id="clipBtn" v-show="!redactImg">截取</div> -->
              <el-button size="medium" id="clipBtn" v-if="!changeImg">截取</el-button>
              <!-- </div> -->
          </el-form-item>
          <!-- 通知改为上传原图，不截取 -->
          <el-form-item label="通知图片" prop="picUrl" v-else>
            <el-upload
              class="avatar-uploader"
              :action="fileUrl"
              :show-file-list="false"
              :data="uploadDataCopy"
              :headers="uploadHeader"
              :on-success="
                (response, file, fileList) => {
                  return handleAvatarSuccess(response, file);
                }
              "
              >
              <img v-if="ruleForm.picUrl" :src="ruleForm.picUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="标题(请不要超过25字)" prop="title" v-if="add_news">
            <br/>
            <el-input v-model="ruleForm.title" placeholder='请输入标题'></el-input>
          </el-form-item>
          <el-form-item label="副标题(请不要超过25字)" prop="subHeading"  v-if="add_news">
            <br/>
            <el-input v-model="ruleForm.subHeading" placeholder='请输入副标题'></el-input>
          </el-form-item>
          <div v-if="add_news_caro">
            <el-form-item :label="article_carouse" prop="resource" required>
              <br/>
              <el-radio-group v-model="ruleForm.resource" @change="ceshi($event)">
                <el-radio label="0">页面内容编辑</el-radio>
                <el-radio label="1">页面内容链接</el-radio>
              </el-radio-group>
              <div class="edit_container" v-if="editorText">
                <el-form-item label="编辑内容" prop="pageContent">
                  <br>
                  <!-- <VueUeditorWrap v-model="ruleForm.pageContent" :config="myConfig"></VueUeditorWrap>  -->
                  <u-editor :config='myConfig' :value='ruleForm.pageContent' @input="getContent"></u-editor>
                </el-form-item>
              </div>
              <div v-if= 'laiyuan'>
                <el-form-item class="old" label-width="300px" label="原文链接（以http://或https://开头）" prop="pageUrl">
                  <el-input class="input80" v-model="ruleForm.pageUrl" placeholder="请输入原文链接"></el-input>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <el-form-item :label="(vtSelect == false)?'同时发布在头条':'同时发布在头条(新闻类可见人员为游客时不可发布在头条)'" prop="isHeadline" v-if="add_news">
            <br/>
            <el-radio-group v-model="ruleForm.isHeadline" :disabled='vtSelect'>
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 同时发布在新闻--轮播类与通知类不管是否,均显示标题缩略图 -->
          <el-form-item label="同时发布在新闻" prop="isNews" v-if="add_caro || add_notice">
            <br/>
            <el-radio-group v-model="ruleForm.isNews" @change="isNewsTitleShow($event)">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
            <div v-if="isNewsTitle">
              <el-form-item label="标题(请不要超过25字)" prop="title">
                <el-input v-model="ruleForm.title" placeholder="请输入新闻标题"></el-input>
              </el-form-item>
              <el-form-item label="副标题(请不要超过25字)" prop="subHeading">
                <el-input v-model="ruleForm.subHeading" placeholder='请输入副标题'></el-input>
              </el-form-item>
              <el-form-item label="缩略图" prop='caroPic'>
                <br/>
                  <input type="hidden" v-model="ruleForm.caroPic">
                  <div class="uploadImg" v-if="!changeImgNews">
                    <el-button size="medium">
                      上传图片
                      <input type="file" id="uploadtImgtx_news" accept="image/*" @change="change123_news($event)">
                    </el-button>
                  </div>
                  <el-button @click="setChangeImgNews" v-if="changeImgNews" id="changeImgBtn" size="medium">更换图片</el-button>
                  <div v-show= "!redactImg_news">
                    <div class="k_news" v-show="!cutImg_news"></div>
                  </div>
                  <div v-show="redactImg_news">
                    <img id="redactImg_news" :src= "imgUrl_news">
                  </div>
                  <div id="news_clipArea" v-show="cutImg_news"></div>
                  <el-button size="medium" id="clipBtn_news" v-if="!changeImgNews">截取</el-button>
              </el-form-item>
            </div>
          </el-form-item>
          <!-- <el-form-item label="发布人" label-width="80px" prop="publishPersion" required>
            <br/>
            <el-input  v-model="ruleForm.publishPersion"></el-input>
          </el-form-item> -->
          <el-form-item label="设置发布时间" prop="publishMethod" required>
            <br/>
            <el-radio-group v-model="ruleForm.publishMethod" @change="changePublishTime($event)">
              <el-radio label="0">手动发布</el-radio>
              <el-radio label="1">定时发布</el-radio>
            </el-radio-group>
            <div v-if= 'timing'>
              <el-form-item label="该内容将于" label-width="100px" prop="publishTime"
              >
              <el-date-picker
                v-model="ruleForm.publishTime"
                type="datetime"
                placeholder="选择日期时间"
                class="datetime2"
                :editable='false'
                :clearable='false'
                >
              </el-date-picker>
              &nbsp;&nbsp;发布
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="" prop="isShare" >
            <el-checkbox-group v-model="ruleForm.isShare">
              <el-checkbox label="是否可以分享给朋友圈以及微信好友"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button v-if='!isValidate' @click="preview('ruleForm')">预览</el-button>
            <el-button v-if='!isValidate' @click="submitForm('ruleForm')">保存</el-button>
            <el-button v-if='isValidate' disabled type= 'info' @click="preview('ruleForm')">预览</el-button>
            <el-button v-if='isValidate' disabled type= 'info' @click="submitForm('ruleForm')">保存</el-button>
            <el-button @click="resetForm('ruleForm')">清空</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-dialog
            title="提示"
            :visible.sync="saveDialogVisible"
            width="30%"
            :before-close="caroHandleClose">
            <span>轮播数量已超过5条，请注意设备显示问题！</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="saveDialogVisible = false">取消保存</el-button>
              <el-button type="primary" @click="saveDialog">确认保存</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import VeeValidate, { Validator} from 'vee-validate'
import getIP from '@/components/utils/getIP'
import sessionstorage from '@/components/cache'
import Vue from 'vue'
import api from '../../../src/modules/api'
import vHeader from '@/layout/Header.vue'
// import VueUeditorWrap from 'vue-ueditor-wrap'
import UEditor from '@/layout/ueditor.vue'
import PhotoClip from 'photoclip_e_x'
import { Loading } from 'element-ui'
// 提示语汉化
Validator.locale = 'zh_CN'
const config = {
  errorBagName: 'errorBags', // change if property conflicts.
  fieldsBagName: 'fieldBags'
}
Vue.use(VeeValidate, config, PhotoClip)

export default {
  components: {
    vHeader,
    // VueUeditorWrap
    UEditor
  },
  data () {
    const title = (rule, value, callback) => {
      // var reg = /'[\\u4E00-\\u9FFF]+', 'g'/
      var myreg = /^.{1,25}$/
      var reg = /^\S*$/
      if (value === '') {
        callback(new Error('请输入标题'))
      } else if (!myreg.test(value)) {
        callback(new Error('请输入25个字以内的标题'))
      } else if (!reg.test(value)) {
        callback(new Error('不能包含空格'))
      } else {
        callback() // 重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
      }
    }
    const subHeading = (rule,value,callback) => {
      var myreg = /^.{1,25}$/
      var reg = /^\S*$/
      if (value === ""){
        callback()
      }else if (!myreg.test(value)) {
        callback(new Error("请输入25个字以内的副标题"))
      }else if(!reg.test(value)) {
        callback(new Error("不能包含空格"))
      }else {
        callback()
      }
    }
    const pageContent = (rule,value,callback) => {
      if (value === '') {
        callback(new Error("请输入内容"))
      }else {
        callback()
      }
    }
    const prodIntroducton = (rule,value,callback) => {
      var myreg = /^.{1,25}$/
      var reg = /^\S*$/
      if (value === '') {
        callback(new Error("请输入产品介绍"))
      }else if(!myreg.test(value)){
        callback(new Error("请输入25个字以内的产品介绍"))
      }else if(!reg.test(value)){
        callback(new Error("不能包含空格"))
      }else {
        callback()
      }
    }
    const keyword = (rule, value, callback) => {
      if(value.length > 5) {
        this.ruleForm.keywords.pop()
      }
      let lastVal = value[value.length-1]
      console.log(value[value.length-1])
      var myreg = /^.{1,10}$/
      var reg = /^\S*$/
      // var comma = /\uff0c/
      if (lastVal === undefined) {
        callback(new Error('请输入关键字'))
      } else if (!myreg.test(lastVal)) {
        callback(new Error('请输入10个字以内的关键字'))
        this.ruleForm.keywords.pop();
      } else if (!reg.test(lastVal)) {
        callback(new Error('不能包含空格'))
        this.ruleForm.keywords.pop();
      }else {
        callback() // 重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
      }
    }
    const pageUrl = (rule, value, callback) => {
      var myreg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
      if (value === '') {
        callback(new Error('请输入链接'))
      } else if (!myreg.test(value)) {
        callback(new Error('请输入正确的链接'))
      } else {
        callback() // 重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
      }
    }
    const publishTime = (rule, value, callback) => {
      if (isNaN(value)) {
        callback(new Error('请选择发布时间'))
      } else if (new Date(value).valueOf() < new Date().valueOf()) {
        callback(new Error('发布时间不能早于当前时间'))
      } else {
        callback() // 重点在这  如果在验证通过后不添加callback()函数在验证时是条件会为false
      }
    }
    return {
      uploadDataCopy: {
        'domain': 'POLICY',
        'buz': 'HONOR_EXCEL',
        'expired': -1,
        'actions': '',
        'buzId': '123',
        'auth': 1
      },
      uploadHeader: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionstorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionstorage.session_get('username')
      },
      fileUrl: '',
      tableHeight:'100%',
      showContent: true,
      pc: null,
      cutImg: true,
      filename: '',
      imgUrl: '',
      showPhotodiv: false,
      redactImg: false,
      uploadUrl: process.env.UPLOAD_ROOT + '/file/v1/hasl/fileAdmin/fileAdmin/upload',
      reddot: false, // header铃铛上面的红点
      dialogVisible: false,
      showImg: true,
      homePage: '',
      name: 'contentControl',
      tabPosition: 'left',
      // activeName: 'list',
      activeName1: 'first',
      title: '',
      keyword: '',
      uploadData: {
        'domain': 'CONTENT',
        'buz': 'PICTURE',
        'expired': -1,
        'actions': '',
        'buzId': '6200155423',
        'auth': 1
      },
      publishVisible: false,
      deleteVisible: false,
      repealVisible: false,
      stickVisible: false,
      cancelTimingVisible: false,
      updateVisible: false,
      updatePublishVisible: false,
      alreadyStickVisible: false,
      count: 0,
      pagesize: 10,
      currentPage: 1,
      publishTypeOptions: [
        {
          value: 'NEWS', label: '新闻类', disabled: false
        },
        {
          value: 'PROD', label: '产品类', disabled: false
        },
        {
          value: 'CARO', label: '轮播类', disabled: false
        },
        {
          value: 'NOTICE', label: '通知类', disabled: false
        }
      ], // 发布类型
      visiblePeopleOptions: [], // 人员可见
      value: '',
      publishContent: '',
      updateDate: '',
      publishDate: '',
      ruleForm: {
        publishType: '',
        visiblePeople: '',
        picUrl: '',
        title: '',
        keywords: [],
        resource: '',
        isHeadline: '',
        publishMethod: '',
        publishTime: '',
        // publishPersion: '',
        pageUrl: '',
        prodIntroducton: '',
        subHeading: '',
        pageContent: '',
        isNews: '',
        isShare: false,
        caroPic: ''
      },
      inputVisible: false,
      inputValue: '',
      options: [
        {value: '0', label: '未发布'},
        {value: '1', label: '发布中'},
        {value: '2', label: '下架'}
      ],
      tableRow: {},
      tableData: [],
      rules: {
        keywords: [
          { required: true, trigger: 'blur', validator: keyword }
        ],
        publishType: [
          { required: true, message: '请选择发布类型', trigger: 'change' }
        ],
        visiblePeople: [
          {required: true, message: '请选择范围', trigger: 'change'}
        ],
        publishTime: [
          { required: true, trigger: 'change', validator: publishTime }
        ],
        title: [
          {required: true, trigger: 'blur', validator: title}
        ],
        subHeading: [
          {required: false,trigger: 'blur',validator: subHeading}
        ],
        resource: [
          {required: true, message: '请选择页面内容', trigger: 'change'}
        ],
        isHeadline: [
          {required: true, message: '请选择是否同时发布头条', trigger: 'change'}
        ],
        publishMethod: [
          {required: true, message: '请选择发布时间', trigger: 'change'}
        ],
        pageUrl: [
          {required: true, trigger: 'blur', validator: pageUrl}
        ],
        pageContent: [
          {required: true, trigger: 'blur', validator: pageContent}
        ],
        picUrl: [
          {required: true, message: '请上传图片'}
        ],
        caroPic: [
          {required: true, message: '请上传图片'}
        ],
        prodIntroducton: [
          {required: true, trigger: 'blur', validator: prodIntroducton}
        ],
        isNews: [
          {required: true, trigger: 'change', message: '请选择是否同时发布在新闻'}
        ]
      },
      header: {
        'ComId': 'ebiz-agent',
        'Authorization': 'Basic ' + sessionstorage.session_get('token'),
        'Accept-Device': 'NULL',
        'Accept-DeviceOS': 'NULL',
        'Accept-Location': 'NULL',
        'Accept-ISP': 'NULL',
        'Accept-StartTime': 'NULL',
        'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
        'Accept-Attr1': getIP.getBrowserInfo(),
        'Accept-Attr2': 'PC',
        'Accept-Attr3': '',
        'Real-Ip': getIP.getBrowserInfo(),
        'Accept-Attr4': 'NULL',
        'Accept-Attr6': sessionstorage.session_get('username')
      },
      shifou: false,
      neirong: '',
      laiyuan: false,
      editorText: false,
      timing: false,
      id: '',
      doUpload: false,
      isValidate: false,
      // fileList2: [],
      fileLst: {},
      add_news: false,
      add_prod: false,
      add_caro: false,
      add_news_caro: false,
      add_notice: false,
      msg:'',//文本编辑器内容
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // UEditor 资源文件的存放路径
        UEDITOR_HOME_URL: './static/Ueditor/',//测试
        // UEDITOR_HOME_URL: '/static/Ueditor/',//本地环境
        //自定义工具栏
        toolbars: [[
            'fullscreen', 'undo', 'redo', '|',
            'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'pasteplain', '|', 'forecolor', 'backcolor', 'cleardoc', '|',
            'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
            'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
            'indent',
            'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
            'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|', 'simpleupload',
            'horizontal', 'date', 'time', 'spechars', '|',
            'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
            'preview', 'searchreplace'
        ]],
        serverUrl: '',
        enableContextMenu: false, //关闭右键菜单
        enableAutoSave: false //关闭自动保存 ueditor.all.js内'contentchange': function添加if(!me.getOpt('enableAutoSave')) {return;}
      },
      isNewsTitle: false,
      thumbnail_pic: '缩略图',
      article_carouse: '文章内容',
      active: true,
      changeImg: false,
      add_new_content: '新建内容',
      loadingOpt: {
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      },
      pc_news: null,
      redactImg_news: false,
      filename_news: '',
      cutImg_news: true,
      fileLst_news: {},
      imgUrl_news:'',
      changeImgNews: false,
      vtSelect: false,
      caroDialogVisible: false,
      saveDialogVisible: false
    }
  },
  watch: {
    ruleForm: {
      handler () {
        if (!this.isValidate) {
          return
        }
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.isValidate = false
          }
        })
      },
      deep: true
    },
    'ruleForm.publishType':{
      handler (newVal) {
        if(this.publishTypeOptions[0].disabled == false && this.publishTypeOptions[1].disabled == false && this.publishTypeOptions[2].disabled == false) {
          this.editorText = false
          this.laiyuan = false
          this.timing = false
          this.isNewsTitle = false
        }
        if(this.imgUrl == '') {
          this.cutImg = true
          if(this.pc != null && this.pc.destroy != undefined) {
            this.pc.destroy()
            this.$nextTick(()=>{
              this.openDiv()
            })
          }
        }
        if(newVal == "NEWS") {
          this.thumbnail_pic = '缩略图'
          this.article_carouse = '文章内容'
          this.add_news = true
          this.add_news_caro = true
          this.add_prod = false
          this.add_caro = false
          this.visiblePeopleOptionsChange(1)
        }else if(newVal == "PROD") {
          this.thumbnail_pic = '缩略图'
          this.add_prod = true
          this.add_news = false
          this.add_caro = false
          this.add_news_caro = false
          this.visiblePeopleOptionsChange(0)
        }else if(newVal == "CARO"){
          this.thumbnail_pic = '轮播图片'
          this.article_carouse = '轮播图内容'
          this.add_caro = true
          this.add_news_caro = true
          this.add_news = false
          this.add_prod = false
          this.visiblePeopleOptionsChange(1)
          if(this.imgUrl_news == '') {
            this.cutImg_news = true
            if(this.pc_news != null && this.pc_news.destroy != undefined) {
              this.pc_news.destroy()
              this.$nextTick(()=>{
                this.openNews()
              })
            }
          }
        } else if (newVal == 'NOTICE'){
          this.thumbnail_pic = '通知图片'
          this.article_carouse = '通知图内容'
          this.add_caro = false
          this.add_news_caro = true
          this.add_news = false
          this.add_prod = false
          this.add_notice = true
          this.visiblePeopleOptionsChange(1)
          if(this.imgUrl_news == '') {
            this.cutImg_news = true
            if(this.pc_news != null && this.pc_news.destroy != undefined) {
              this.pc_news.destroy()
              this.$nextTick(()=>{
                this.openNews()
              })
            }
          }
          this.$nextTick(() => {
            // 初始化通知类
            this.ruleForm.resource = '0' // 通知图内容--默认页面编辑内容
            this.ruleForm.pageContent = '无' // 通知图内容--默认页面编辑内容--无
            this.ceshi(this.ruleForm.resource);
            this.ruleForm.publishMethod = '0' // 设置发布时间--默认手动
            this.changePublishTime(this.ruleForm.publishMethod);
            this.ruleForm.isNews = '0' // 同时发布在新闻--默认否
            this.ruleForm.title = '无' // 同时发布在新闻的标题--无
            this.isNewsTitleShow(this.ruleForm.isNews);
          })
          
        }else {
          this.thumbnail_pic = '缩略图'
          this.article_carouse = '文章内容'
          this.add_news = false
          this.add_news_caro = false
          this.add_prod = false
          this.add_caro = false
        }
        if(this.$refs['ruleForm'] != undefined) {
          this.$refs['ruleForm'].resetFields()
          this.ruleForm.publishType = newVal
        }
      }
    },
    'ruleForm.visiblePeople': {
      handler (newVal) {
        this.ruleForm.isHeadline = '0'
        if(newVal == 'VT') {
          this.vtSelect = true
        }else {
          this.vtSelect = false
        }
      }
    }
  },
  //页面跳转前判断
  beforeRouteLeave (to, from , next) {
    if(this.add_new_content == '返回列表页') {
      // this.$confirm('此操作将丢失已编辑的内容, 是否继续?', '确认信息', {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: '确认',
      //     cancelButtonText: '取消'
      //   })
      //   .then(() => {
      //     next()
      //   })
      //   .catch(() => {
      //     next(false)
      //   });
      const answer = window.confirm('此操作将丢失已编辑的内容, 是否继续?')
      if (answer) {
          next()
      } else {
          next(false)
      }
    }else {
      next()
    }
  },
  // computed: {
  //   editor () {
  //     return this.$refs.myQuillEditor.quill
  //   }
  // },
  methods: {
    handleAvatarSuccess(res, file) {
      if(res.result.isSuccess){
        this.ruleForm.picUrl = this.$linkUrl + res.data.fileId + '.' + res.data.ext
      }
    },
    visiblePeopleOptionsChange (a) {
      if ( a == 1) {
        let arr = []
        for (let i = 0; i< this.visiblePeopleOptions.length; i++) {
          arr.push(this.visiblePeopleOptions[i].label)
        }
          if(arr.indexOf('游客') == -1) {
            this.visiblePeopleOptions.unshift({label:"游客",value: "VT"})
          }
      }else {
        this.visiblePeopleOptions.shift()
      }
    },
    getTableHeight () {
      let height = document.querySelectorAll('.el-tab-pane')[0].clientHeight
      this.tableHeight = height - 105
    },
    opened () {
      alert('opened')
    },
    close () {
      alert('close')
    },
    closed () {
      alert('closed1111')
    },
    change123 (val) {
      this.cutImg = true
      this.filename = val.currentTarget.files[0].name
      this.showImg = false
      this.redactImg = false
    },
    openDiv () {
      let _this = this
      let size = []
      let clipArea = document.getElementById('clipArea')
      let k = document.getElementsByClassName('k')[0]
      if(_this.ruleForm.publishType == 'PROD') {
        size = [321,178]
        k.style.width = clipArea.style.width = 30 + 'vw'
        k.style.height = clipArea.style.height = 44 + 'vh'
      }else if(_this.ruleForm.publishType == 'CARO'){
        // size = [400,118.4]
        size = [375, 217.5]
        k.style.width = clipArea.style.width = 36 + 'vw'
        k.style.height = clipArea.style.height = 32 + 'vh'
      } else if(_this.ruleForm.publishType == 'NOTICE') {
        size = [291, 528]
        k.style.width = clipArea.style.width = 36 + 'vw'
        k.style.height = clipArea.style.height = 32 + 'vh'
      }else {
        size = [240,155]
        k.style.width = clipArea.style.width = 25 + 'vw'
        k.style.height = clipArea.style.height = 38.7 + 'vh'
      }
      _this.pc = new PhotoClip('#clipArea', {
        size: size,
        outputSize: 340,
        file: '#uploadtImgtx',
        view: '.k',
        ok: '#clipBtn',
        loadStart: function () {
          console.log('开始读取照片')
        },
        loadComplete: function () {
          console.log('照片读取完成')
        },
        done: function (dataURL) {
          _this.redactImg = false
          if (!_this.cutImg) {
            _this.$message( {
              message: '请勿重复截取',
              type: 'warning'
            })
          } else {
            _this.fileLst = _this.dataURLtoFile(dataURL, _this.filename)
            _this.uploadImg(_this.fileLst,0)
          }
        },
        fail: function (msg) {
          _this.$message.error(msg)
        }
      })
    },
    dataURLtoFile (dataurl, filename) { // 将base64转换为文件
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {type: mime})
    },
    uploadImg (fileList,a) { // 上传图片
      // console.log(this.fileLst)
      // let a = fileLst
      let fd = new FormData()
      fd.append('domain', 'CONTENT')
      fd.append('buz', 'PICTURE')
      fd.append('expired', -1)
      fd.append('actions', '')
      fd.append('buzId', '6200155423')
      fd.append('file', fileList)
      fd.append('auth', 1)
      let _this = this
      let url = _this.uploadUrl
      axios({
        method: 'post',
        url,
        data: fd,
        // withCredentials: true,
        timeout: 30 * 1000, // 30秒超时
        headers: {
          'ComId': 'ebiz-agent',
          'Authorization': 'Basic ' + sessionstorage.session_get('token'),
          'Accept-Device': 'NULL',
          'Accept-DeviceOS': 'NULL',
          'Accept-Location': 'NULL',
          'Accept-ISP': 'NULL',
          'Accept-StartTime': 'NULL',
          'Accept-TimeZone': -(new Date().getTimezoneOffset() * 60000),
          'Accept-Attr1': getIP.getBrowserInfo(),
          'Accept-Attr2': 'PC',
          'Accept-Attr3': '',
          'Real-Ip': getIP.getBrowserInfo(),
          'Accept-Attr4': 'NULL',
          'Accept-Attr6': sessionstorage.session_get('username')
        }
      }).then(response => {
        if (response.data.result.isSuccess == true) {
          let data = response.data.data
          if (a == 0) {
            _this.ruleForm.picUrl = _this.$linkUrl + data.fileId + '.' + data.ext
            _this.cutImg = false
          }else {
            _this.ruleForm.caroPic = _this.$linkUrl + data.fileId + '.' + data.ext
            _this.cutImg_news = false
          }
        }
      }).catch(error => {
        if (error) {
          console.log(error)
          // reject(new Error('接口调用失败'))
        }
      })
    },
    // 重置
    reset () {
      this.title = ''
      this.keyword = ''
      this.value = ''
    },
    search () {
      this.commonMethod()
    },
    // 获取发布类型
    getInitpublishTypes () {
      let msg = {}
      let that = this
      api.initPublishTypes(msg, (res) => {
        console.log("获取发布类型",res)
        if (res.result.isSuccess === true) {
          if (res.data.length !== 0) {
            for (let i = 0; i < res.data.length; i++) {
              that.publishTypeOptions.push({'value': res.data[i].typeCode, 'label': res.data[i].typeName})
            }
          }
        } else {
          console.log(res.result.error)
        }
      })
    },
    // 获取人员可见
    getVisiblePeopleOptions () {
      let msg = {}
      let that = this
      api.initVisiblePeople(msg, (res) => {
        if (res.result.isSuccess === true) {
          let visiblePeopleOptions = []
          if (res.data.length !== 0) {
            for (let i = 0; i < res.data.length; i++) {
              visiblePeopleOptions.push({'value': res.data[i].code, 'label': res.data[i].name})
            }
            that.visiblePeopleOptions = visiblePeopleOptions
          }
        } else {
          console.log(res.result.error)
        }
      })
    },
    // 获取内容列表
    getContentList () {
      this.contentListMethod("NEWS");
    },
    //获取内容列表接口方法
    contentListMethod(a, b = 1){
      let msg = {
        title: this.title,
        keywords: this.keyword,
        publishStatus: this.value,
        publishType: a,
        pageSize: 10,
        pageNum: b
      }
      let that = this
      that.currentPage = b
      that.tableData = []
      let loadingInstance = Loading.service(this.loadingOpt)
      api.searchContent(msg, (res) => {
        console.log(res, '====查询列表====')
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        that.tableData = [] //再次清空，防止此时用户点击其他类别再次返回数据，会造成两次数据都会显示到页面的情况
        if (res.result.isSuccess === true) {
          let response = res.data.contentList
          that.count = res.data.totals
          response.forEach(resData => {
            if (resData.publishTime !== undefined) {
              let timestamp1 = new Date(resData.publishTime)
              resData.publishTime = timestamp1.toLocaleDateString().replace(/\//g, '-') + ' ' + timestamp1.toTimeString().substr(0, 8)
            }
            if (resData.unshelveDate !== undefined) {
              let timestamp2 = new Date(resData.unshelveDate)
              resData.unshelveDate = timestamp2.toLocaleDateString().replace(/\//g, '-') + ' ' + timestamp2.toTimeString().substr(0, 8)
            }
            if(resData.publishStatus == 1 && this.activeName1 == 'first'){
              resData.address = this.$pageAdressUrl + resData.id
            }else {
              resData.address = ''
              resData.headline = false
            }
            if(resData.keywords !== undefined) {
              resData.keywords = resData.keywords.split(',')
            }
            that.tableData.push(resData)
          })
        } else {
          console.log(res.result.error)
        }
      })
    },
    handleClickLeft () {
      if(this.add_new_content == '新建内容') {
        this.add_new_content = '返回列表页'
        this.getVisiblePeopleOptions()
      }else {
        this.add_new_content = "新建内容"
        // this.$confirm('此操作将丢失已编辑的内容, 是否继续?', '确认信息', {
        //   distinguishCancelAndClose: true,
        //   confirmButtonText: '确认',
        //   cancelButtonText: '取消'
        // })
        // .then(() => {
        //   this.commonMethod()
        //   this.active = !this.active
        //   this.publishTypeOptions[0].disabled = false
        //   this.publishTypeOptions[1].disabled = false
        //   this.publishTypeOptions[2].disabled = false
        // })
        // .catch(action => {
        //   this.add_new_content = '返回列表页'
        // });
        const answer = window.confirm('此操作将丢失已编辑的内容, 是否继续?')
        if (answer) {
          this.commonMethod()
          this.active = !this.active
          this.publishTypeOptions[0].disabled = false
          this.publishTypeOptions[1].disabled = false
          this.publishTypeOptions[2].disabled = false
          this.id = ''
        } else {
          this.add_new_content = '返回列表页'
        }
        return
      }
      if(this.pc != null && typeof this.pc.destroy === 'function') {
        this.pc.destroy()
      }
      this.$nextTick(()=>{
        this.openDiv()
      })
      this.isNewsTitle = false
      this.active = !this.active
      this.changeImg = false
      this.id = ''
      this.imgUrl = ''
      this.imgUrl_news = ''
      this.changeImgNews = false
      let that = this
      that.isValidate = false
      that.cutImg = true
      that.redactImg = false
      that.redactImg_news = false
      that.pageNum = 1
      that.currentPage = 1
      that.title = ''
      that.keyword = ''
      that.value = ''
      that.filename = ''
      that.ruleForm = {
        publishType: '',
        visiblePeople: '',
        picUrl: '',
        title: '',
        keywords: [],
        resource: '',
        isHeadline: '',
        publishMethod: '',
        publishTime: '',
        pageUrl: '',
        prodIntroducton: '',
        subHeading: '',
        pageContent: '',
        isNews: '',
        isShare:'',
        caroPic:''
      }
      that.redactImg = false
      that.laiyuan = false
      that.editorText = false
      that.timing = false
      // that.handleRemove()
      var container = document.querySelector('#main_div')
      container.scrollTop = 0
      // that.$refs['ruleForm'].resetFields()
      this.publishTypeOptions[0].disabled = false
      this.publishTypeOptions[1].disabled = false
      this.publishTypeOptions[2].disabled = false
    },
    //公用获取数据
    commonMethod () {
      let publishType
      if(this.activeName1 == "first"){
        publishType = "NEWS"
      }else if(this.activeName1 == "second"){
        publishType = "PROD"
      }else if(this.activeName1 == 'third'){
        publishType = "CARO"
      } else {
        publishType = 'NOTICE'
      }
      console.log(publishType,"类型")
      this.contentListMethod(publishType);
    },
    handleClick (tab, event) {
      console.log(tab, event)
      let publishType = ""
      if(tab.index == 0){
        publishType = "NEWS"
        this.activeName1 = "first"
      }else if(tab.index == 1){
        publishType = "PROD"
        this.activeName1 = "second"
      }else if (tab.index == 2){
        publishType = "CARO"
        this.activeName1 = "third"
      } else {
        publishType = "NOTICE"
        this.activeName1 = "four"
      }
      this.reset()
      this.contentListMethod(publishType)
    },
    // 发布按钮弹窗
    publish (row) {
      console.log(row)
      this.publishVisible = true
      this.publishContent = row.title
      this.tableRow = row
    },
    publishClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    isPublish (num) {
      let msg = {
        id: this.tableRow.id
      }
      let textMessage
      if(num == 0) {
        textMessage = '撤销发布'
      }else {
        textMessage = '发布'
      }
      api.publishContent(msg, res => {
        this.publishVisible = false
        this.repealVisible = false
        this.updatePublishVisible = false
        if (res.result.isSuccess === true) {
          this.commonMethod()
          this.$message({
            message: textMessage + '成功',
            type: 'success'
          });
        } else {
          if(res.result.error != undefined) {
            if(res.result.errorCode === 'E1001'){
              this.caroDialogVisible = true
            }else{
              this.$message(textMessage + '失败，' + res.result.error);
            }
          }else {
            this.$message(textMessage + '失败，请稍后再试')
          }
        }
      })
    },
    caroHandleClose(done) {
      done()
    },
    caroDialog() {
      let msg = {
        id: this.tableRow.id,
        forceSubmit: true
      }
      api.publishContent(msg, res => {
        this.caroDialogVisible = false
        if (res.result.isSuccess === true) {
          this.commonMethod()
          this.$message({
            message:  '发布成功',
            type: 'success'
          });
        } else {
          if(res.result.error != undefined) {
            this.$message(textMessage + '失败，' + res.result.error)
          }else {
            this.$message(textMessage + '失败，请稍后再试')
          }
        }
      })
    },
    // 撤销发布按钮弹窗
    repealPublish (row) {
      this.tableRow = {}
      this.repealVisible = true
      this.publishContent = row.title
      this.tableRow = row
    },
    repealClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    updatePublishClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    updatePublishContent () {

    },
    // 删除按钮弹窗
    deleteData (row) {
      this.tableRow = row
      this.deleteVisible = true
      this.publishContent = row.title
    },
    deleteClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    isDelete () {
      let msg = {
        id: this.tableRow.id
      }
      if (this.tableRow.contentType == 2 && this.activeName1 == 'first') {
        msg.publishType = 'NEWS'
      }
      api.deleteContent(msg, res => {
        this.deleteVisible = false
        if (res.result.isSuccess === true) {
          this.commonMethod()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        } else {
          console.log(res.result.error)
          this.$message('删除失败，请稍后再试')
        }
      })
    },
    // 取消定时发布
    cancelData (row) {
      this.tableRow = row
      this.cancelTimingVisible = true
      this.publishContent = row.title
    },
    cancelTimingClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    cancelTiming () {
      let msg = {
        id: this.tableRow.id
      }
      api.cancelTiming(msg, res => {
        this.cancelTimingVisible = false
        if (res.result.isSuccess === true) {
          this.commonMethod()
          this.$message({
            message: '取消定时发布成功',
            type: 'success'
          })
        } else {
          console.log(res.result.error)
          this.$message('取消定时发布失败，请稍后再试')
        }
      })
    },
    // 修改定时发布时间
    update (row) {
      this.tableRow = row
      this.updateVisible = true
      this.updateDate = row.publishTime
    },
    updateClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    cancelUpdate () {
      this.updateVisible = false
      this.updateDate = ''
    },
    updatePublish () {
      console.log(new Date(this.updateDate).valueOf() > new Date().valueOf())
      if (new Date(this.updateDate).valueOf() > new Date().valueOf()) {
        let msg = {
          id: this.tableRow.id,
          publishTime: new Date(this.updateDate).valueOf()
        }
        api.updatePublishTime(msg, res => {
          this.updateVisible = false
          if (res.result.isSuccess === true) {
            this.commonMethod()
            this.$message({
              message: '修改自动发布时间成功',
              type: 'success'
            })
          }else {
            this.$message('修改自动发布时间失败，请稍后再试')
          }
        })
      } else if (this.updateDate === '') {
        this.$message({
          message: '发布时间不能为空',
          type: 'warning'
        })
      } else if (new Date(this.updateDate).valueOf() < new Date().valueOf()) {
        this.$message({
          message: '发布时间不能早于当前时间',
          type: 'warning'
        })
      }
    },
    // 编辑按钮弹窗
    redact (row) {
      console.log(row,"编辑")
      if (row.publishStatus === 1) {
        this.tableRow = {}
        this.updatePublishVisible = true
        this.publishContent = row.title
        this.tableRow = row
      } else {
        this.isValidate = false
        this.add_new_content = '返回列表页'
        this.ruleForm.pageContent = ''
        this.ruleForm.pageUrl = ''
        this.ruleForm.title = ''
        this.ruleForm.publishTime = ''
        this.editorText = false
        this.laiyuan = false
        this.isNewsTitle = false
        this.timing = false
        this.id = row.id
        let msg = {
          id: row.id
        }
        let that = this
        let loadingInstance = Loading.service(this.loadingOpt)
        api.getContent(msg, res => {
          console.log(res);
          if (res.result.isSuccess === true) {
            that.cutImg = false
            that.redactImg = true
            this.active = !this.active
            this.changeImg = true
            that.imgUrl = res.data.picUrl
            that.ruleForm.publishType = res.data.publishType
            that.ruleForm.visiblePeople = res.data.visiblePeople
            that.ruleForm.keywords = res.data.keywords.split(',')
            that.ruleForm.picUrl = res.data.picUrl
            if(res.data.isShare == 1) {
              that.ruleForm.isShare = true
            }else {
              that.ruleForm.isShare = false
            }
            if(res.data.title != undefined) {
              that.ruleForm.title = res.data.title
            }
            if(res.data.subHeading == undefined){
              that.ruleForm.subHeading = ""
            }else {
              that.ruleForm.subHeading = res.data.subHeading
            }
            that.ruleForm.publishMethod = res.data.publishMethod + ''
            if (res.data.publishMethod == 1) {
              that.ruleForm.publishTime = new Date(res.data.publishTime).toLocaleDateString().replace(/\//g, '-') + ' ' + new Date(res.data.publishTime).toTimeString().substr(0, 8)
              that.timing = true
            }
            console.log(that.ruleForm.publishMethod)
            //新闻类或轮播类公共部分字段
            if(res.data.publishType == 'CARO' || res.data.publishType == 'NEWS' || res.data.publishType == 'NOTICE') {
              if(res.data.pageUrl != undefined){
                that.ruleForm.pageUrl = res.data.pageUrl
                that.ruleForm.resource = "1"
                that.laiyuan = true
              }else if(res.data.pageUrl == undefined){
                that.ruleForm.pageContent = res.data.pageContent
                that.ruleForm.resource = "0"
                this.editorText = true
              }
            }
            //新闻类私有字段
            if(res.data.publishType == 'NEWS'){
              if(res.data.isHeadline != undefined){
                that.ruleForm.isHeadline = res.data.isHeadline + ''
              }
              this.publishTypeOptions[1].disabled = true
              this.publishTypeOptions[2].disabled = true
            }
            //产品类私有字段
            if(res.data.publishType == 'PROD'){
              if(res.data.prodIntroducton != undefined){
                that.ruleForm.prodIntroducton = res.data.prodIntroducton
              }else {
                that.ruleForm.prodIntroducton = ""
              }
              that.ruleForm.pageUrl = res.data.pageUrl
              this.publishTypeOptions[0].disabled = true
              this.publishTypeOptions[2].disabled = true
            }
            //轮播类私有字段
            if(res.data.publishType == 'CARO' || res.data.publishType == 'NOTICE'){
              that.ruleForm.isNews = res.data.isNews + ''
              if(res.data.isNews == 0) {
                this.isNewsTitle = false
              } else {
                this.isNewsTitle = true
                that.cutImg_news = false
                that.redactImg_news = true
                this.imgUrl_news = this.ruleForm.caroPic = res.data.caroPic
                this.changeImgNews = true
              }
              this.publishTypeOptions[1].disabled = true
              this.publishTypeOptions[0].disabled = true
            }
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          }
        })
      }
    },
    // 置顶按钮弹窗
    stick (row) {
      this.tableRow = row
      this.stickVisible = true
      this.publishContent = row.title
    },
    stickClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    isStick (num) {
      let msg = {
        id: this.tableRow.id
      }
      let textMessage
      api.stickContent(msg, res => {
        if (num == 0) {
          textMessage = '取消置顶'
          this.alreadyStickVisible = false
        }else {
          textMessage = '置顶'
          this.stickVisible = false
        }
        if (res.result.isSuccess === true) {
          this.commonMethod()
          this.$message({
            message: textMessage + '成功',
            type: 'success'
          })
        } else {
          console.log(res.result.error)
          this.$message(textMessage + '失败，请稍后再试')
        }
      })
    },
    alreadyStick (row) {
      this.tableRow = row
      this.alreadyStickVisible = true
      this.publishContent = row.title
    },
    alreadyStickClose (done) {
      done()
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done()
      //   })
      //   .catch(_ => {})
    },
    // 新建内容选择内容来源
    ceshi (data) {
      if (data === '1') {
        this.ruleForm.pageContent = ''
        this.laiyuan = true
        this.editorText = false
        // this.words = ''
        // this.pageUrl = ''
      } else {
        this.ruleForm.pageUrl = ''
        this.laiyuan = false
        this.editorText = true
        // this.words = ''
        // this.pageUrl = ''
      }
    },
    // 新建内容设置是否定时发布
    changePublishTime (data) {
      this.ruleForm.publishTime = ''
      if (data === '1') {
        this.timing = true
      } else {
        this.timing = false
      }
    },
    // onEditorReady (editor) {
    // },
    visiblePeople (row, column) {
      return row.visiblePeople === 'VT' ? '游客' : row.visiblePeople === 'ALL' ? '全公司' : row.visiblePeople === 'FC' ? '个险' : row.visiblePeople === 'GP' ? '团险' : row.visiblePeople === 'BK' ? '银保' : row.visiblePeople === 'AD' ? '多元' : '续保'
    },
    contentTypes (row, column) {
      return row.contentType === 0 ? '原创' : row.contentType === 1 ? '外部链接' : '轮播类'
    },
    formatStatus (row, column) {
      return row.publishStatus === 0 ? '未发布' : row.publishStatus === 1 ? '发布中' : '下架'
    },
    // 预览内容请求数据
    preview (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isValidate = false
          console.log(this.isValidate)
          console.log(this.ruleForm)
          // let that = this
          // if (!this.doUpload) {
          //   that.rules.picUrl = []
          //   that.rules.picUrl = [{ required: true, message: '请上传图片' }]
          // } else {
          //   that.$refs['uploadElement'].clearValidate()
          // }
          let msg = {}
          msg.picUrl = this.imgUrl
          msg.isShare = 0
          let loadingInstance = Loading.service(this.loadingOpt)
          if (this.ruleForm.resource === '1') { //新闻类、轮播类的页面内容链接的预览请求数据
            msg.previewUrl = this.ruleForm.pageUrl
            if(this.ruleForm.title != '') {
              msg.title = this.ruleForm.title
            }else {
              msg.title = '轮播类预览'
            }
            console.log("新闻类、轮播类的页面内容链接的预览请求数据",msg)
            this.sendPreview(msg,loadingInstance)
          }else if(this.ruleForm.resource === '0'){ //新闻类、轮播类的页面内容编辑（富文本）的预览请求数据
            console.log(this.ruleForm.title)
            msg.previewUrl = ''
            if(this.ruleForm.title != '') {
              msg.title = this.ruleForm.title
            }else {
              msg.title = '轮播类预览'
            }
            //为表格添加边框，不添加手机端不显示边框
            let pageContent = this.ruleForm.pageContent
            if(pageContent.indexOf('<table>') != -1) {
              let arr = pageContent.split('<table>')
              let pageContentChange = ''
              for(var i = 0; i < arr.length-1; i++) {
                if(arr[i] == '') {
                  pageContentChange += '<table border="1" cellpadding="10" cellspacing="0" style="margin-top:10px">'
                } else {
                  pageContentChange += arr[i] + '<table border="1" cellpadding="10" cellspacing="0" style="margin-top:10px">'
                }
              }
              pageContentChange += arr[arr.length-1]
              pageContent = pageContentChange
            }
            let message = {}
            if(this.id != '') {
              message.id = this.id
            }
            message.pageContent = pageContent
            api.savePreviewContent(message, res => {
              console.log("保存富文本信息",res)
              if(res.result.isSuccess === true) {
                msg.id = res.data
                this.sendPreview(msg,loadingInstance)
              }else {
                console.log(res.result.error)
              }
            })
            console.log("新闻类、轮播类的页面内容编辑（富文本）的预览请求数据",msg)
          }else if(this.ruleForm.resource == ''){ //产品类的预览请求数据
            msg.title = this.ruleForm.title
            msg.previewUrl = this.ruleForm.pageUrl
            this.sendPreview(msg,loadingInstance)
          }
        } else {
          this.isValidate = true
          console.log('error submit!!')
          return false
        }
      })
    },
    //发送预览请求
    sendPreview(msg,loadingInstance){
      api.previewContent(msg, res => {
        console.log(res)
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          this.$message({
            message: '发送预览成功，请在易捷消息中心内查看',
            type: 'success'
          })
        } else {
          console.log(res.result.error)
          this.$message({
            message: '发送预览失败，请稍后再试',
            type: 'error'
          })
        }
      })
    },
    // 保存内容
    submitForm (formName) {
      this.ruleForm.publishTime = new Date(this.ruleForm.publishTime).valueOf()
      // this.ruleForm.picUrl = 'http://111.160.216.85/eapp2/eapp-getFile/salm-62002057.jpg'
      // this.ruleForm.isHeadline = '0'
      // if (this.id == '') {
      //   this.ruleForm.id = this.id
      // }
      // let that = this
      // if (!this.doUpload || this.ruleForm.picUrl === '') {
      //       console.log("判断是否上传图片")
      //   that.rules.picUrl = []
      //   that.rules.picUrl = [{ required: true, message: '请上传图片' }]
      // } else {
      //   that.$refs['uploadElement'].clearValidate()
      // }
      console.log(this.ruleForm)
      this.$refs[formName].validate((valid,errors) => {
        if (valid) {
          this.isValidate = false
          let msg = {}
          if(this.id != ''){
            msg.id = this.id
          }
          msg.publishType = this.ruleForm.publishType
          msg.visiblePeople = this.ruleForm.visiblePeople
          msg.keywords = this.ruleForm.keywords.join(',')
          msg.picUrl = this.ruleForm.picUrl
          // msg.publishPersion = this.ruleForm.publishPersion
          msg.publishMethod = parseInt(this.ruleForm.publishMethod)
          if(msg.publishMethod == 1) {
            msg.publishTime = this.ruleForm.publishTime
          }
          if(this.ruleForm.isShare == true){
            msg.isShare = 1
          }else {
            msg.isShare = 0
          }
          if(this.ruleForm.publishType == 'NEWS' || this.ruleForm.publishType == 'CARO' || this.ruleForm.publishType == 'NOTICE') {
            if(this.ruleForm.pageUrl == ''){
              msg.contentType=this.ruleForm.resource = 0
              //为表格添加边框，不添加手机端不显示边框
              let pageContent = this.ruleForm.pageContent
              if(pageContent.indexOf('<table>') != -1) {
                let arr = pageContent.split('<table>')
                let pageContentChange = ''
                for(var i = 0; i < arr.length-1; i++) {
                  if(arr[i] == '') {
                    pageContentChange += '<table border="1" cellpadding="10" cellspacing="0" style="margin-top:10px">'
                  } else {
                    pageContentChange += arr[i] + '<table border="1" cellpadding="10" cellspacing="0" style="margin-top:10px">'
                  }
                }
                pageContentChange += arr[arr.length-1]
                pageContent = pageContentChange
              }
              msg.pageContent = pageContent
            }else {
              msg.contentType=this.ruleForm.resource = 1
              msg.pageUrl = this.ruleForm.pageUrl
            }
          }
          if(this.ruleForm.publishType == 'NEWS'){
            msg.title = this.ruleForm.title
            if(this.ruleForm.subHeading != '') {
              msg.subHeading = this.ruleForm.subHeading
            }
            msg.isHeadline = parseInt(this.ruleForm.isHeadline)
          }else if (this.ruleForm.publishType == 'PROD') {
            msg.title = this.ruleForm.title
            msg.prodIntroducton = this.ruleForm.prodIntroducton
            msg.pageUrl = this.ruleForm.pageUrl
          }else if (this.ruleForm.publishType == 'CARO' || this.ruleForm.publishType == 'NOTICE'){
            msg.isNews = parseInt(this.ruleForm.isNews)
            if(this.ruleForm.title != '') {
            msg.title = this.ruleForm.title
            }
            if(this.ruleForm.subHeading != '') {
            msg.subHeading = this.ruleForm.subHeading
            }
            if(this.ruleForm.caroPic != '') {
              msg.caroPic = this.ruleForm.caroPic
            }
          }
          console.log("入参",msg)
          let loadingInstance = Loading.service(this.loadingOpt)
          api.saveContent(msg, res => {
            console.log(res)
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
            if (res.result.isSuccess === true) {
              this.commonMethod()
              this.title = ''
              this.keyword = ''
              this.active = true
              this.add_new_content = '新建内容'
              this.$message({
                message: '保存成功',
                type: 'success'
              })
            } else {
              if(res.result.errorCode === 'E1001') {
                this.saveDialogVisible = true
              }else {
                this.$message({
                  message: res.result.error,
                  type: 'warning'
                });
              }
            }
          })
        } else {
          // 校验出错返回到错误处
          for(let i in errors) {
            if(i === 'publishType' || i === 'visiblePeople' || i === 'keywords') {
              document.documentElement.scrollTop = document.body.scrollTop = 0
              document.getElementsByClassName('all-form')[0].scrollTop = 0
            }else if(i === 'picUrl' && this.ruleForm.publishType == 'NEWS') {
              document.documentElement.scrollTop = document.body.scrollTop = 0
              document.getElementsByClassName('all-form')[0].scrollTop = 300
            }else if(i === 'title' && this.ruleForm.publishType == 'NEWS') {
              document.documentElement.scrollTop = document.body.scrollTop = 0
              document.getElementsByClassName('all-form')[0].scrollTop = 500
            }else if((this.ruleForm.publishType == 'PROD' && i === 'title') || (this.ruleForm.publishType == 'PROD' && i === 'prodIntroducton') || (this.ruleForm.publishType == 'PROD' && i === 'pageUrl')) {
              document.documentElement.scrollTop = document.body.scrollTop = 0
              document.getElementsByClassName('all-form')[0].scrollTop = 350
            }else if((this.ruleForm.publishType == 'CARO' || this.ruleForm.publishType == 'NOTICE') && i === 'picUrl'){
              document.documentElement.scrollTop = document.body.scrollTop = 0
              document.getElementsByClassName('all-form')[0].scrollTop = 350
            }
          }
          this.isValidate = true
          console.log('error submit!!')
          return false
        }
      })
    },
    saveDialog() {
      let msg = {}
      if(this.id != ''){
        msg.id = this.id
      }
      msg.publishType = this.ruleForm.publishType
      msg.visiblePeople = this.ruleForm.visiblePeople
      msg.keywords = this.ruleForm.keywords.join(',')
      msg.picUrl = this.ruleForm.picUrl
      // msg.publishPersion = this.ruleForm.publishPersion
      msg.publishMethod = parseInt(this.ruleForm.publishMethod)
      if(msg.publishMethod == 1) {
        msg.publishTime = this.ruleForm.publishTime
      }
      if(this.ruleForm.isShare == true){
        msg.isShare = 1
      }else {
        msg.isShare = 0
      }
      if(this.ruleForm.publishType == 'NEWS' || this.ruleForm.publishType == 'CARO') {
        if(this.ruleForm.pageUrl == ''){
          msg.contentType=this.ruleForm.resource = 0
          //为表格添加边框，不添加手机端不显示边框
          let pageContent = this.ruleForm.pageContent
          if(pageContent.indexOf('<table>') != -1) {
            let arr = pageContent.split('<table>')
            let pageContentChange = ''
            for(var i = 0; i < arr.length-1; i++) {
              if(arr[i] == '') {
                pageContentChange += '<table border="1" cellpadding="10" cellspacing="0" style="margin-top:10px">'
              } else {
                pageContentChange += arr[i] + '<table border="1" cellpadding="10" cellspacing="0" style="margin-top:10px">'
              }
            }
            pageContentChange += arr[arr.length-1]
            pageContent = pageContentChange
          }
          msg.pageContent = pageContent
        }else {
          msg.contentType=this.ruleForm.resource = 1
          msg.pageUrl = this.ruleForm.pageUrl
        }
      }
      if(this.ruleForm.publishType == 'NEWS'){
        msg.title = this.ruleForm.title
        if(this.ruleForm.subHeading != '') {
          msg.subHeading = this.ruleForm.subHeading
        }
        msg.isHeadline = parseInt(this.ruleForm.isHeadline)
      }else if (this.ruleForm.publishType == 'PROD') {
        msg.title = this.ruleForm.title
        msg.prodIntroducton = this.ruleForm.prodIntroducton
        msg.pageUrl = this.ruleForm.pageUrl
      }else if (this.ruleForm.publishType == 'CARO' || this.ruleForm.publishType == 'NOTICE'){
        msg.isNews = parseInt(this.ruleForm.isNews)
        if(this.ruleForm.title != '') {
        msg.title = this.ruleForm.title
        }
        if(this.ruleForm.subHeading != '') {
        msg.subHeading = this.ruleForm.subHeading
        }
        if(this.ruleForm.caroPic != '') {
          msg.caroPic = this.ruleForm.caroPic
        }
      }
      msg.forceSubmit = true
      console.log("入参",msg)
      let loadingInstance = Loading.service(this.loadingOpt)
      api.saveContent(msg, res => {
        console.log(res)
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          this.saveDialogVisible = false
          this.commonMethod()
          this.title = ''
          this.keyword = ''
          this.active = true
          this.add_new_content = '新建内容'
          this.$message({
            message: '保存成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.result.error,
            type: 'warning'
          });
        }
      })
    },
    beforeUpload (file) {
      // this.ruleForm.picUrl = file.url
      console.log(file)
      return true
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      let pubType = ''
      if(this.publishTypeOptions[0].disabled == false || this.publishTypeOptions[1].disabled == false || this.publishTypeOptions[2].disabled == false) {
        pubType = this.ruleForm.publishType
        this.setChangeImg()
      }
      this.ruleForm = {
        publishType: '',
        visiblePeople: '',
        picUrl: '',
        title: '',
        keywords: [],
        resource: '',
        isHeadline: '',
        publishMethod: '',
        publishTime: '',
        // publishPersion: '',
        pageUrl: '',
        prodIntroducton: '',
        subHeading: '',
        pageContent: '',
        isNews: '',
        isShare: false,
        caroPic:''
      }
      this.ruleForm.publishType = pubType
      this.cutImg = true
      this.redactImg = false
      this.cutImg_news = true
      this.redactImg_news = false
      // this.fileList2 = []
      // this.handleRemove()
      this.editorText = false
      this.laiyuan = false
      this.timing = false
      this.isNewsTitle = false
      this.isValidate = false
    },
    // handleRemove (file, fileList) {
    //   this.doUpload = false
    //   this.ruleForm.picUrl = ''
    //   this.rules.picUrl = [{ required: true, message: '请上传图片' }]
    // },
    // handlePreview (file) {
    //   console.log(this.ruleForm.picUrl !== '')
    //   if (this.ruleForm.picUrl !== '') {
    //     this.$message({
    //       message: '最多只能上传一张图片',
    //       type: 'warning'
    //     })
    //   }
    // },
    // handlePictureCardPreview (file) {
    //   // this.fileList2 = []
    //   console.log(file)
    //   this.dialogImageUrl = file.url
    //   // this.ruleForm.picUrl = file.url
    //   // this.fileList2.push(file.url)
    //   // this.doUpload = true
    //   // this.$refs['uploadElement'].validateField('picUrl')
    // },
    // handleSuccess (res, file) {
    //   console.log(res)
    //   this.ruleForm.picUrl = 'https://testfile.ihasl.com/file/v1/hasl/fileAdmin/fileAdmin/get/' + res.data.fileId + '.' + res.data.ext
    // },
    handleCurrentChange (val) {
      let publishType
      if(this.activeName1 == "first"){
        publishType = "NEWS"
      }else if(this.activeName1 == "second"){
        publishType = "PROD"
      }else if(this.activeName1 == "third"){
        publishType = "CARO"
      } else {
        publishType = "NOTICE"
      }
      this.contentListMethod(publishType,val)
    },
    // 登出
    notLogOut () {
      this.dialogVisible = false
      this.$message({
        type: 'info',
        message: '取消退出'
      })
    },
    logOut () {
      this.delCookie('jtl')
      this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
      window.location.href = this.$logOutFront + encodeURIComponent(this.$logOutBack + encodeURIComponent(this.homePage + this.$address))
    },
    validateForm () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.isValidate = false
        }
      })
    },
    getCookie (key) {
      var arr, reg = RegExp('(^| )' + key + '=([^;]+)(;|$)')
      if (arr = document.cookie.match(reg)) // ["username=liuwei;", "", "liuwei", ";"]
      { return decodeURIComponent(arr[2]) } else { return null }
    },
    delCookie (key) {
      var date = new Date()
      date.setTime(date.getTime() - 1)
      var delValue = this.getCookie(key)
      if (delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString()
      }
    },
    isNewsTitleShow(e){
      // console.log(e)
      // if(e == '1') {
      //   this.isNewsTitle = true
      //   this.$nextTick(()=>{
      //     this.openNews()
      //   })
      // }else {
      //   this.ruleForm.title = ''
      //   this.isNewsTitle = false
      // }
      this.isNewsTitle = true
      this.$nextTick(()=>{
        this.openNews()
      })
    },
    openNews () {
      let _this = this
      _this.pc_news = new PhotoClip('#news_clipArea', {
        size: [240,155],
        outputSize: 340,
        file: '#uploadtImgtx_news',
        view: '.k_news',
        ok: '#clipBtn_news',
        loadStart: function () {
          console.log('开始读取照片')
        },
        loadComplete: function () {
          console.log('照片读取完成')
        },
        done: function (dataURL) {
          _this.redactImg_news = false
          if (!_this.cutImg_news) {
            _this.$message( {
              message: '请勿重复截取',
              type: 'warning'
            })
          } else {
            _this.fileLst_news = _this.dataURLtoFile(dataURL, _this.filename_news)
            _this.uploadImg(_this.fileLst_news,1)
          }
        },
        fail: function (msg) {
          _this.$message.error(msg)
        }
      })
    },
    change123_news (val) {
      console.log(val)
      this.cutImg_news = true
      this.filename_news = val.currentTarget.files[0].name
      console.log(this.filename_news)
      this.redactImg_news = false
    },
    setChangeImgNews () {
      this.changeImgNews = false
      if (this.pc_news != null) {
        this.pc_news.destroy()
      }
      this.$nextTick(() => {
        this.openNews()
      })
      this.imgUrl_news = ''
      this.ruleForm.caroPic = ''
      this.cutImg_news = true
      this.redactImg_news = false
    },
    setChangeImg () {
      this.changeImg = false
      if(this.pc != null) {
        this.pc.destroy()
      }
      this.$nextTick(()=>{
        this.openDiv()
      })
      this.imgUrl = ''
      this.ruleForm.picUrl = ''
      this.cutImg = true
      this.redactImg = false
    },
    getContent(obj){
      this.ruleForm.pageContent = obj.content
    },
    handleClose(tag) {
      this.ruleForm.keywords.splice(this.ruleForm.keywords.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      for(let i = 0; i < this.ruleForm.keywords.length; i++) {
        if(this.ruleForm.keywords[i] == inputValue) {
          this.inputVisible = false;
          this.inputValue = '';
          return
        }
      }
      if (inputValue) {
        this.ruleForm.keywords.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    beforeLeave() {
      if(this.add_new_content == '返回列表页') {
        return window.onbeforeunload = function (e) {
          e = e || window.event;
          // 兼容IE8和Firefox 4之前的版本
          if (e) {
            e.returnValue = '关闭提示';
          }
          // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
          return '关闭提示';
        }
      }else {
        return window.onbeforeunload = null
      }
    }
  },
  mounted () {
    this.fileUrl = this.$uploadImg;
    // this.openDiv()
    // this.getInitpublishTypes()
    this.getVisiblePeopleOptions()
    this.getContentList()
    this.$nextTick( () => { this.getTableHeight() })
    // this.getContent()
  },
  beforeUpdate() {
    this.beforeLeave()
  },
  activated () {
    let that = this
    // this.getHeader()
    that.ruleForm = {
      publishType: '',
      visiblePeople: '',
      picUrl: '',
      title: '',
      keywords: [],
      resource: '',
      isHeadline: '',
      publishMethod: '',
      publishTime: '',
      // publishPersion: '',
      pageUrl: '',
      prodIntroducton: '',
      subHeading: '',
      pageContent: '',
      isNews: '',
      isShare: false,
      caroPic: ''
    }
    var container = document.querySelector('#main_div')
    container.scrollTop = 0
    if(this.$refs['ruleForm']){
      this.$refs['ruleForm'].resetFields()
    }
    // that.activeName = 'list'
    that.activeName1 = 'first'
    // this.getContentList()
    this.commonMethod()
  }
}

</script>
<style lang="css">
#content{
  height: 100%;
  box-sizing: border-box;
}
.showContent {
    width: 20vw;
    height: 30vh;
    margin: 0 auto;
    margin-top: 35vh;
}

.authorityImg {
    width: 20vw;
    height: 25vh;
  }

  .noAuthority {
    padding-top: 1vh;
    text-align: center;
    color: #9D9D9D;
    font-size: 45px;
  }
  .k_news{
    width: 25vw;
    height:38.7vh;
  }
  #uploadtImgtx,#uploadtImgtx_news{
    width: 11.5vw;
    height: 6vh;
    position: absolute;
    top:0;
    left: 0;
    opacity: 0;
  }
  .uploadImg{
    position: relative;
    overflow: hidden;
    display: inline-block;
    margin-right: 30px;
  }
  #clipBtn{
    cursor: pointer;
  }
  #redactImg{
    /* width: 25vw;
    height:38.7vh; */
    padding-top:20px;
  }
  #news_clipArea {
    height: 38.7vh;
    width: 25vw;
    margin-bottom: 10px;
  }
  .el-tabs--border-card>.el-tabs__content {
    padding: 6px 0 6px 25px;
  }
  .el-tabs--left.el-tabs--border-card .el-tabs__header.is-left{
    z-index: 20;
  }
  .el-tabs--left.el-tabs--border-card .el-tabs__header.is-left{
    height: 100vh;
    position: fixed;
  }
  /* .el-tabs__content{
    margin:1% 0 0 2%;
  } */
  /* .el-tabs__header {
    margin-left: 2%
  } */
  #pane-add {
    margin-left: 4%
  }
  #pane-add .el-form-item__content {
    margin-left: 30px !important;
  }
  #pane-add .el-select {
    width: 100% !important;
  }
  .searchParam{
    width: 100%;
    display: inline-block;
    border-bottom: solid #cccccc;
    padding-bottom: 10px;
  }
.all-form{
  /* width:100%; */
  padding-top:30px;
  margin-left: 3%;
  height: calc(100% - 30px);
  overflow: auto;
}
.all-form::-webkit-scrollbar {
  width: 0px;
}
  .el-table td{
    text-align: center
  }
  .el-table th{
    text-align: center
  }
  .el-form-item__label{
  text-align: left
}
.input60{
width: 60%;
}
.el-pagination{
  text-align: center
}
/* .margintop{
  margin-top: 30px;
} */
.contentCon{
  width:96%;
  margin:0 auto;
  padding-top:30px;
  height:calc(100% - 70px);
  overflow: auto;
  box-sizing: border-box;
  position: relative;
}
.contentCon::-webkit-scrollbar{width: 0px;}
.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active{
  font-size: 16px
}
.contentUrl{
  width: 73px;
  font-size: 13px;
  color: #606266;
}
.input80{
  width: 93%;
}
#clipBtn {
  display: block;
  margin-top: 20px;
}
.v-modal {
  z-index:1000 !important;
}
.el-table th>.cell {
  text-align: center;
}
.el-form-item__content {
  margin-left: 40px !important;
  margin-bottom: 10px;
}
.el-badge__content.is-fixed {
  top: 6px;
}
.margintop .el-table td:last-child>.cell {
  text-align:left;
}
.el-picker-panel__footer>button.el-button.el-picker-panel__link-btn.el-button--text.el-button--mini {
  display: none;
}
.edui-default .edui-editor-breadcrumb {
  display: none;
}
.input-new-tag.el-input.el-input--small>.el-input__inner{
  width:15%
}
</style>
<style scoped>
.el-button--text{
  display: none;
}
#changeImgBtn {
  margin-bottom: 20px;
}
.el-pagination {
  margin:8px 0;
}
#add {
  position: absolute;
  top: 20px;
  right: 30px;
  z-index: 20;
}
.all-form .el-select, .all-form .el-input, .el-form-item__content>div:nth-child(3) {
  width:80%;
}
.margintop .badge {
  background-color: #ccc;
  display: block;
  border-radius: 8px;
  font-size: 12px;
  color: #FFF;
  text-align: center;
}
.margintop .badge.headline {
  background-color: #F56C6C;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.margintop.contentCon >>> .el-tabs.el-tabs--top, .margintop.contentCon >>> .el-tab-pane {
  height: 100%;
}
.margintop.contentCon >>> .el-tabs__content {
  height: calc(100% - 50px);
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/contents/contentControl.vue